/** @file Inspector header: the kind, the name (renamed inline when the kind can be), and Delete. */
import { useState } from 'react';
import type { EntityKind } from '@pose2d/format/types';
import { deletable } from '../../forms/deletable';
import { DeleteDialog } from '../../forms/DeleteDialog';
import { entityName } from '../../forms/entityName';
import { FormStatus } from '../../forms/FormStatus';
import { submitCalls, type SubmitResult } from '../../forms/submitCalls';
import { Button } from '../../ui-kit/Button';
import { TextInput } from '../../ui-kit/TextInput';
import { ENTITY_FORMS } from './entityForms.data';
import type { EntityViewProps, FormKind } from './formKindOf';

const entityOf = (kind: FormKind): EntityKind | null => (kind === 'project' ? null : kind === 'region' || kind === 'mesh' ? 'attachment' : kind);

/** The project shows its name only (project rename lives in the Projects browser); a generated socket bone cannot be renamed, and Delete is off for what the commands refuse. */
export function EntityHeader({ doc, kind, id, t }: EntityViewProps) {
  const [deleting, setDeleting] = useState(false);
  const [status, setStatus] = useState<SubmitResult | null>(null);
  const entity = entityOf(kind);
  const generated = kind === 'bone' && doc.bones[id]?.kind !== undefined;
  const rename = generated ? null : ENTITY_FORMS[kind].rename;
  const name = entity === null ? doc.meta.name : entityName(doc, entity, id);
  return (
    <header className="p2-inspector-header">
      <h3 className="p2-inspector-kind">{t(`panels.inspector.kinds.${kind}`)}</h3>
      {rename === null ? <span className="p2-inspector-name">{name}</span>
        : <TextInput label={t('panels.inspector.name')} value={name} onCommit={(next) => { void submitCalls([{ name: rename, input: { target: id, name: next } }]).then(setStatus); }} />}
      {entity !== null && <Button label={t('panels.inspector.delete')} danger disabled={!deletable(doc, { kind: entity, id })} onClick={() => { setDeleting(true); }} />}
      {entity !== null && <DeleteDialog doc={doc} targets={deleting ? [{ kind: entity, id }] : null} t={t} onClose={() => { setDeleting(false); }} onDone={setStatus} />}
      <FormStatus status={status} t={t} />
    </header>
  );
}
